const css = `._089_qq__months{grid-template-columns:repeat(1,max-content);row-gap:16px;display:grid}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"months":"_089_qq__months"};
